/**
 * New Colors
 * 
 * Main Palette
 * https://coolors.co/586ba4-282a2a-f5dd90-f68e5f-f76c5e
 * 
 * Secondary Palette
 * https://coolors.co/94a0c5-767777-f8e9b8-f9b799-f9a198
 */


/*
   Color Palette

   https://coolors.co/cad2c5-84a98c-52796f-354f52-2f3e46


*/

module.exports.colors = {
  /**
   * New Colors
   */
  // Main
  white: '#FFFFFF',
  black: '#282A2A',
  // Secondary
  darkBlue: '#586BA4',
  darkRed: '#F76C5E',
  darkOrange: '#F68E5F',
  red: '#F9A198',
  yellow: '#F8E9B8',
  orange: '#F9B799',
  blue: '#94A0C5',
  lightGray: '#F2F2F2',







  // Main palette
  mainBg: '#FFF',
  mainColor: '#2E2C2D',
  offWhite: '#CAD2C5',
  lightGreen:'#84A98C',
  mediumGreen: '#52796F',
  darkGreen: '#354F52',
  darkestGreen: '#2F3E46',
  lightOffGreen: '#E9EFEA',

  //
  //
  // Finalized collors
  //
  //
  // templateMainColor: '#B2DBCC',
  templateMedColor: '#CEE8DE',
  templateLightColor: '#DCEEE7',
  // member redesign
  lightCyan: '#D1F5FF',
  diamond: '#BBF0FF',
  // react template
  azureishWhite: '#D6F2ED',
  powderBlue: '#AEE5DC',
  // batman poster
  lemonChiffon: '#FDF9CD',
  // cycles
  manatee: '#A09DAE',
  rhythm: '#7A768E',
  // comboSmash
  lemonMeringue: '#FAE9BD',
  peachYellow: '#F8E1A3',
};
